import { useTranslation } from 'react-i18next'
import { articlesPath, currentLocale, localeRootPath } from './i18n'
import LanguageSwitcher from './LanguageSwitcher'

type PublicHeaderProps = {
  standalone?: boolean
  active?: 'articles'
}

function HeaderLogo({ href }: { href: string }) {
  const { t } = useTranslation()
  return (
    <a className="logo" href={href} aria-label={t('accessibility.backToTop')}>
      <span className="brand-mark brand-mark--compact" aria-hidden="true" />
      <span>SIDEWISP</span>
    </a>
  )
}

function ArrowIcon() {
  return (
    <svg className="arrow-icon" viewBox="0 0 18 18" fill="none" aria-hidden="true">
      <path d="M3.75 9h10.5M10 4.75 14.25 9 10 13.25" />
    </svg>
  )
}

export default function PublicHeader({ standalone = false, active }: PublicHeaderProps) {
  const { t } = useTranslation()
  const locale = currentLocale()
  const localeRoot = localeRootPath(locale)
  const sectionPrefix = standalone ? localeRoot : ''

  return (
    <header className="site-header">
      <HeaderLogo href={standalone ? localeRoot : '#top'} />
      <nav aria-label={t('accessibility.primaryNav')}>
        <a href={`${sectionPrefix}#product`}>{t('nav.product')}</a>
        <a href={`${sectionPrefix}#checks`}>{t('nav.checks')}</a>
        <a href={`${sectionPrefix}#recovery`}>{t('nav.recovery')}</a>
        <a href={`${sectionPrefix}#integrations`}>{t('nav.integrations')}</a>
        <a href={articlesPath(locale)} aria-current={active === 'articles' ? 'page' : undefined}>{t('nav.articles')}</a>
      </nav>
      <div className="header-actions">
        <LanguageSwitcher reloadOnChange={standalone} />
        <a href={`${sectionPrefix}#waitlist`}>{t('nav.earlyAccess')} <ArrowIcon /></a>
      </div>
    </header>
  )
}
